<app-social-button
  e2eId="connect-with-apple"
  [icon]="appleIcon"
  [disabled]="!(initialized$ | async) || (processing$ | async)"
  [isLoading]="processing$ | async"
  i2gTrackable
  [trackingObject]="trackingObject"
  [trackingAction]="trackingAction"
  [trackingAdditionalProperties]="trackingAdditionalProperties"
  (buttonClick)="signInToApple()"
>
</app-social-button>
